module.exports = __webpack_public_path__ + "img/bg.ef4f1c64.svg";